module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_prf_r1.htm"
    }
  }, [_vm._v("List of Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_map_r1.htm"
    }
  }, [_vm._v("Map of Oberhochwald and Vicinity")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_prf2_r1.htm"
    }
  }, [_vm._v("Preface: Anton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c01_r1.htm"
    }
  }, [_vm._v("I. August, 1348: At Matins, The Commemoration of Sixtus II and His Companions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c02_r1.htm"
    }
  }, [_vm._v("  1. Now: Sharon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c03_r1.htm"
    }
  }, [_vm._v("II. August, 1348: At Primes, The Commemoration of Sixtus II and His Companions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c04_r1.htm"
    }
  }, [_vm._v("III. August, 1348: At Compline, The Vigil of St. Laurence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c05_r1.htm"
    }
  }, [_vm._v("IV. August, 1348: The Feast of St. Clare of Assisi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c06_r1.htm"
    }
  }, [_vm._v("  2. Now: Tom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c07_r1.htm"
    }
  }, [_vm._v("V. August, 1348: The Feast of St. Joachim")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c08_r1.htm"
    }
  }, [_vm._v("VI. September, 1348: The Stigmata of St. Francis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c09_r1.htm"
    }
  }, [_vm._v("VII. September, 1348: The Apparition of Our Lady of Ransom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c10_r1.htm"
    }
  }, [_vm._v("VIII. October, 1348: Michaelmas to the Feriae Messis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c11_r1.htm"
    }
  }, [_vm._v("  3. Now: Sharon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c12_r1.htm"
    }
  }, [_vm._v("IX. October, 1348: The Freiburg Markets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c13_r1.htm"
    }
  }, [_vm._v("X. November, 1348: The Commemoration of Florentius of Strassburg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c14_r1.htm"
    }
  }, [_vm._v("  4. Now: Tom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c15_r1.htm"
    }
  }, [_vm._v("XI. November, 1348: The Kermis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c16_r1.htm"
    }
  }, [_vm._v("XII. January, 1348: Before Matins, The Epiphany of the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c17_r1.htm"
    }
  }, [_vm._v("XIII. January, 1348: Rock Monday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c18_r1.htm"
    }
  }, [_vm._v("  5. Now: Sharon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c19_r1.htm"
    }
  }, [_vm._v("XIV. February, 1348: Candlemas to the Ember Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c20_r1.htm"
    }
  }, [_vm._v("XV. March, 1349: At Sext, Ember Wednesday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c21_r1.htm"
    }
  }, [_vm._v("XVI. March, 1349: Lent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c22_r1.htm"
    }
  }, [_vm._v("  6. Now: Tom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c23_r1.htm"
    }
  }, [_vm._v("XVII. April/May, 1349: Until Rogation Sunday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c24_r1.htm"
    }
  }, [_vm._v("XVIII. June, 1349: At Tierce, The Commemoration of Ephraem of Syria")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c25_r1.htm"
    }
  }, [_vm._v("XIX. June, 1349: At Nones, The Commemoration of Bernard of Menthon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c26_r1.htm"
    }
  }, [_vm._v("XX. June, 1349: From the Commemoration of St. Herve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c27_r1.htm"
    }
  }, [_vm._v("XXI. June, 1349: The Nativity of St. John the Baptist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c28_r1.htm"
    }
  }, [_vm._v("XXII. June, 1349: Until Nones, The Seven Holy Brothers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c29_r1.htm"
    }
  }, [_vm._v("  7. Now: Sharon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c30_r1.htm"
    }
  }, [_vm._v("XXIII. July, 1349: The Feast of St. Margaret of Antioch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c31_r1.htm"
    }
  }, [_vm._v("XXIV. July, 1349: At Primes, The Commemoration of St. Hilarinus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c32_r1.htm"
    }
  }, [_vm._v("  8. Now: Sharon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c33_r1.htm"
    }
  }, [_vm._v("XXV. July, 1349: Ferial Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c34_r1.htm"
    }
  }, [_vm._v("  9. Now: Tom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_c35_r1.htm"
    }
  }, [_vm._v("  10. Now: Anton")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_app1_r1.htm"
    }
  }, [_vm._v("Historical Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_app2_r1.htm"
    }
  }, [_vm._v("Physics Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780765340351_epub_app3_r1.htm"
    }
  }, [_vm._v("A Note on Terms and Sources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58acebf7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780765340351_epub_toc_r1.vue
// module id = 78
// module chunks = 0